import { render, staticRenderFns } from "./StackedHorizontalChart.global.vue?vue&type=template&id=6080cf32&scoped=true&lang=pug&"
import script from "./StackedHorizontalChart.global.vue?vue&type=script&lang=ts&"
export * from "./StackedHorizontalChart.global.vue?vue&type=script&lang=ts&"
import style0 from "./StackedHorizontalChart.global.vue?vue&type=style&index=0&id=6080cf32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080cf32",
  null
  
)

export default component.exports